import React from 'react';
import { TextInput } from 'react-admin';

class SanitizedTextInput extends React.Component {
  sanitizeInput = (input) => {
    //console.log('Getting inside to the senitize text box...');
    //console.log('Type of input is ' + (typeof input));
    if (typeof input === 'string') {
      input =  input.replace(/[=+\-@]/g, '');
    }
    //console.log('Input: ' + input);
    return input;
  }

  render() {
    const { source, ...rest } = this.props;
    return (
      <TextInput 
        {...rest}
        source={source}
        parse={this.sanitizeInput}
      />
    );
  }
}

export default SanitizedTextInput;